import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  Divider,
  FormControl,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";

import apis from "../../apis";
import { handleCallApiError } from "../../errors";
import Dialog from "../../components/Dialog";
import { BOOKING_STATUS_LABEL } from "../../constants/booking";

const BookingNoteDialog = ({ open, handleClose, type, item, reload }) => {
  const [note, setNote] = useState("");
  const [noteError, setNoteError] = useState("");
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState("");

  const handleCloseDialog = () => {
    handleClose();
    setNote("");
    setNoteError("");
  };

  const handleUpdateOrder = async () => {
    setLoading(true);
    try {
      if (type === "booking") {
        await apis.booking.updateBooking(item.id, {
          note,
          status: status === item.status ? undefined : status,
        });
      } else {
        await apis.booking.updateBookingItem(item.id, { note });
      }
      handleCloseDialog();
      reload();
      toast.success("Cập nhật ghi chú thành công");
    } catch (error) {
      handleCallApiError(error);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (open && item) {
      setNote(item.note || "");
      if (type === "booking") {
        setStatus(item.status || "");
      }
    }
  }, [open, item, type]);

  return (
    <Dialog
      title={type === "booking" ? "Cập nhật đặt lịch" : "Thêm ghi chú"}
      subTitle={
        type === "booking"
          ? `${item?.customer?.name} - ${item?.customer?.phoneNumber}`
          : item?.name
      }
      maxWidth="sm"
      open={open}
      onClose={handleCloseDialog}
    >
      <DialogContent>
        <Box mb={2}>
          <Typography fontWeight={500} mb={1}>
            Ghi chú:
          </Typography>
          <TextField
            error={!!noteError}
            helperText={noteError}
            value={note}
            size="small"
            fullWidth
            onChange={(event) => setNote(event.target.value)}
            multiline={true}
            rows={5}
          />
        </Box>
        {type === "booking" && (
          <Box mb={2}>
            <Typography fontWeight={500} mb={1}>
              Trạng thái:
            </Typography>
            <FormControl fullWidth>
              <Select
                labelId="status-select-label"
                value={status}
                onChange={(event) => setStatus(event.target.value)}
                size="small"
              >
                {Object.keys(BOOKING_STATUS_LABEL).map((key) => (
                  <MenuItem key={key} value={key}>
                    {BOOKING_STATUS_LABEL[key]}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        )}
      </DialogContent>
      <Divider />
      <DialogActions>
        <Button
          variant="outlined"
          color="secondary"
          onClick={handleCloseDialog}
        >
          Hủy
        </Button>

        <LoadingButton
          variant="contained"
          color="success"
          loading={loading}
          onClick={handleUpdateOrder}
        >
          Lưu thay đổi
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default BookingNoteDialog;
